import { Checkbox, makeStyles, TableCell, TableRow } from '@material-ui/core';
import React from 'react'
import IconEstado from '../../../autorizaciones/UI/IconEstado';
import { formatCurrencyPesos } from '../../../../helpers/extraFunctions';


const useRowStyles = makeStyles({
    root: {
        "& > *": {
            borderBottom: "unset",
        },
    },
});

const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

export const ComprobantesItems = (props) => {

    const classes = useRowStyles();

    const { item, isItemSelected, labelId, handleClick } = props;

    return (
        <TableRow className={classes.root} >

            <TableCell align='center'>
                <Checkbox
                    checked={isItemSelected}
                    inputProps={{ "aria-labelledby": labelId }}
                    onClick={(event) => handleClick(event, item)}
                />
            </TableCell>
            <TableCell align="center">
                <IconEstado
                    useColorTable={true}
                    texto={item?.expediente?.estadoComprobante?.letraLiquidaciones}
                    backgroundColor={item?.expediente?.estadoComprobante?.colorLiquidaciones}
                    descripcion={item?.expediente?.estadoComprobante?.descripcionLiquidaciones}
                />
            </TableCell>
            <TableCell align="left">{item?.idComprobante}</TableCell>
            <TableCell align="left" style={{ minWidth: 150 }}>
                {`${item?.nroSucursal.toString().padStart((5), '0')}-${item?.nroFactura.toString().padStart((8), '0')}`}
            </TableCell>
            <TableCell align="left">{item?.comprobanteContrato?.efectorFacturacion?.razonSocial}</TableCell>
            <TableCell align="left">{item?.comprobanteContrato?.efectorFacturacion?.cuit}</TableCell>
            <TableCell align="left">
                {(() => {
                    switch (item?.procedencia?.descripcion) {
                        case 'Mail':
                            return 'M';
                        case 'Correo':
                            return 'C';
                        case 'Otras Areas':
                            return 'O';
                        case 'En mano':
                            return 'EM';
                        default:
                            return '';
                    }
                })()}
            </TableCell>
            <TableCell align="left">{`${formatCurrencyPesos(item?.totalComprobante)}`}</TableCell>
            <TableCell align="center">{item?.tipoFactura?.descripcion}</TableCell>
            <TableCell align="center">
                {new Date(item.expediente?.fechaRecepcion).toLocaleString("es", optionsfecha)}
            </TableCell>
            <TableCell align="center">
                {item.fechaVencimiento
                    ? new Date(item.fechaVencimiento).toLocaleString("es", optionsfecha)
                    : null
                }
            </TableCell>
        </TableRow>
    )
}
